<template>
  <v-app id="app">
    <router-view></router-view>
    <confirm-dialog ref="confirm" />
  </v-app>
</template>
<style>
  @import '~izitoast/dist/css/iziToast.css';
  @import '~vue2-animate/dist/vue2-animate.css';
  @import '~v-autocomplete/dist/v-autocomplete.css';
  @import "~vue-material-design-icons/styles.css";
</style>
<style lang="scss">
  // Import Main styles for this application
  @import './scss/style';
</style>
<script>
import ConfirmDialog from '@/utils/ConfirmDialog'
export default {
  components: {ConfirmDialog},
  mounted () {
    this.$root.$confirm = this.$refs.confirm.open
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue